import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const EmptyState = ({ height = 297, width = 297, ...props }: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 297 297" {...props}>
    <path
      d="M268.333,166.337c-0.002-17.698-3.965-35.172-11.598-51.139c-7.633-15.968-18.743-30.025-32.515-41.14c-13.772-11.116-29.857-19.008-47.076-23.098c-17.22-4.091-35.136-4.275-52.436-0.541c-17.299,3.734-33.544,11.293-47.543,22.122C63.167,83.369,51.769,97.194,43.808,113c-7.961,15.807-12.283,33.195-12.65,50.89c-0.367,17.694,3.231,35.246,10.53,51.369h216.089C264.749,199.893,268.348,183.211,268.333,166.337z"
      fill="#F5F4F4"
    />
    <path
      d="M32.615,215.258h231.27"
      fill="none"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.272,215.258h7.413"
      fill="none"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M269.815,215.258h7.413"
      fill="none"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M266.387,239.748c0,3.048-48.038,5.791-107.735,5.791c-59.697,0-107.691-2.591-107.691-5.791s48.037-5.791,107.691-5.791C218.306,233.957,266.387,236.7,266.387,239.748z"
      fill="#F5F4F4"
    />
    <path d="M137.232,206.383h26.409v15.847h-26.409V206.383z" fill="#FFFFFF" />
    <path
      d="M137.232,206.383h26.409v15.847h-26.409V206.383z"
      fill="none"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M184.771,232.793h-68.666c0-1.388,0.273-2.763,0.804-4.045c0.532-1.283,1.31-2.448,2.292-3.429c0.981-0.982,2.147-1.761,3.429-2.292c1.282-0.531,2.657-0.804,4.045-0.804h47.539c2.801,0.003,5.486,1.118,7.466,3.1C183.659,227.305,184.771,229.992,184.771,232.793L184.771,232.793z"
      fill="#FFFFFF"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M232.31,98.098c0-1.734-0.341-3.452-1.004-5.054c-0.664-1.602-1.636-3.058-2.863-4.285c-1.226-1.227-2.682-2.199-4.284-2.863c-1.602-0.664-3.319-1.005-5.054-1.005H81.77c-1.734,0-3.452,0.342-5.054,1.005c-1.602,0.664-3.058,1.637-4.284,2.863c-1.226,1.226-2.199,2.682-2.862,4.285c-0.663,1.602-1.005,3.32-1.004,5.054v87.156H232.31V98.098z"
      fill="#E6FFF7"
    />
    <path
      d="M232.31,98.098c0-1.734-0.341-3.452-1.004-5.054c-0.664-1.602-1.636-3.058-2.863-4.285c-1.226-1.227-2.682-2.199-4.284-2.863c-1.602-0.664-3.319-1.005-5.054-1.005H81.77c-1.734,0-3.452,0.342-5.054,1.005c-1.602,0.664-3.058,1.637-4.284,2.863c-1.226,1.226-2.199,2.682-2.862,4.285c-0.663,1.602-1.005,3.32-1.004,5.054v87.156H232.31V98.098z"
      fill="none"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M219.105,206.381c1.734,0,3.451-0.342,5.053-1.005c1.603-0.664,3.058-1.636,4.284-2.863c1.227-1.226,2.199-2.682,2.863-4.284c0.663-1.602,1.005-3.319,1.005-5.053v-7.922H68.566v7.922c0,3.502,1.391,6.861,3.868,9.337c2.476,2.477,5.835,3.868,9.337,3.868H219.105z"
      fill="#FFFFFF"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M147.309,195.818c0,0.83,0.33,1.626,0.917,2.213c0.587,0.588,1.383,0.917,2.214,0.917c0.83,0,1.626-0.329,2.213-0.917c0.587-0.587,0.917-1.383,0.917-2.213c0-0.83-0.33-1.627-0.917-2.214c-0.587-0.587-1.383-0.916-2.213-0.916c-0.831,0-1.627,0.329-2.214,0.916C147.639,194.191,147.309,194.988,147.309,195.818z"
      fill="#622C6A"
    />
    <path
      d="M84.437,97.289h132.001v18.547H84.437V97.289z"
      fill="#FFFFFF"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M216.438,185.254h-37.131v-56.009c0-0.718,0.285-1.408,0.793-1.916c0.509-0.508,1.198-0.794,1.917-0.794h31.711c0.719,0,1.408,0.286,1.916,0.794c0.509,0.508,0.794,1.198,0.794,1.916V185.254z"
      fill="#FFFFFF"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M84.437,126.535h82.516v18.547H84.437V126.535z"
      fill="#FFFFFF"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M132.475,155.777h34.481v18.547h-34.481V155.777z"
      fill="#FFFFFF"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M84.437,155.777h34.481v18.547H84.437V155.777z"
      fill="#FFFFFF"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M54.558,161.832c0-1.105,0.895-2,2-2h33.804c1.104,0,2,0.895,2,2v65.307c0,1.104-0.896,2-2,2H56.558c-1.105,0-2-0.896-2-2V161.832z"
      fill="#FFFFFF"
      stroke="#4550E5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M54.558,161.832c0-1.105,0.895-2,2-2h33.804c1.104,0,2,0.895,2,2v65.307c0,1.104-0.896,2-2,2H56.558c-1.105,0-2-0.896-2-2V161.832z"
      fill="none"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M54.558,167.707h37.804v53.554H54.558V167.707z" fill="#E6FBFF" />
    <path
      d="M84.178,178.526c0,0.496-0.097,0.986-0.286,1.444c-0.189,0.458-0.467,0.874-0.818,1.224c-0.35,0.35-0.766,0.628-1.224,0.818c-0.458,0.189-0.948,0.286-1.444,0.286H66.512c-0.981-0.028-1.914-0.437-2.598-1.141s-1.068-1.647-1.068-2.629s0.383-1.925,1.068-2.629s1.617-1.114,2.598-1.141h13.894c0.495-0.001,0.985,0.097,1.443,0.286c0.457,0.189,0.873,0.467,1.224,0.817c0.35,0.35,0.628,0.765,0.818,1.222C84.08,177.541,84.178,178.031,84.178,178.526z"
      fill="#FFFFFF"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M62.744,190.715h21.434v23.263H62.744V190.715z"
      fill="#FFFFFF"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M54.558,167.707h37.804v53.554H54.558V167.707z"
      fill="none"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M187.325,136.352c0-1.105,0.896-2,2-2h71.368c1.104,0,2,0.895,2,2v91.953c0,1.104-0.896,2-2,2h-71.368c-1.104,0-2-0.896-2-2V136.352z"
      fill="#FFFFFF"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M196.149,146.645h57.722v71.37h-57.722V146.645z"
      fill="#FFF8D9"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M204.638,155.398h40.742v12.803h-40.742V155.398z"
      fill="#FFFFFF"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M233.297,175.926h12.083v33.332h-12.083V175.926z"
      fill="#FFFFFF"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M204.638,175.926h20.372v12.803h-20.372V175.926z"
      fill="#FFFFFF"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M204.638,196.457h20.372v12.803h-20.372V196.457z"
      fill="#FFFFFF"
      stroke="#622C6A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M79.26,100h0.81c0.11,0,0.2,0.09,0.2,0.2v0.5c0,0.166-0.134,0.3-0.3,0.3h-0.71V100z"
      fill="#622C6A"
    />
  </SvgIcon>
);
